import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { addValidator, required } from 'redux-form-validators';
import { deleteImgs } from '../../../../helpers/Fields/EditorMedia/actions';
import SelectFieldAnt from '../../../../helpers/Fields/SelectFieldAnt';
import TreeSelectField from '../../../../helpers/Fields/TreeSelectField';

import './style.scss';
import { setCartItemCopy } from '../../../actions';
import { toastr } from 'react-redux-toastr';

export class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.deleteImages = [];
    this.state = {
      spinner: true,
      modal: false,
    }
  }

  submit = async (value) => {
    const {createCard, handleClose2, setCartItemCopy} = this.props;
    const {formatMessage} = this.context;
    try {
      handleClose2();
      await createCard(value);
      setCartItemCopy(value)
      toastr.success(formatMessage('msgTitleNotificationCardCopy'), formatMessage('msgNotificationCardCopy'))
    } catch (error) {
      console.log("🚀 ~ FormContent ~ submit= ~ error:", error)
      
    }
    
  }

  render() {
    const {formatMessage} = this.context;
    const {handleSubmit, handleClose, change, setCartItemCopy} = this.props;
    const {categories, subjects, valuesForm} = this.props;
    const {modal} = this.state;

    let tree = [];

    if(valuesForm && valuesForm.subject_id){
      categories.filter(_i => _i.subject_id == valuesForm.subject_id).forEach(cat => {
        if(!cat.parent_id){
          tree.push({
            title: cat.name,
            value: cat.id,
            children: []
          })
        }
      });
    }
    

    categories.forEach(cat => {
      if(cat.parent_id){
        tree.forEach(item => {
          if(item.value == cat.parent_id){
            item.children.push({
              title: cat.name,
              value: cat.id,
            })
          }
        })
      }
    });

    return <form className='CardFormData' onSubmit={handleSubmit(this.submit)}>
      <Field 
        name='subject_id'
        label={formatMessage('cardSubject')}
        component={SelectFieldAnt}
        handleChange={() => {
          change('category_id', '')
        }}
        options={subjects.map(_i => ({value: _i.id, title: _i.name}))}
        validate={[required()]}
      />
      <Field 
        name='category_id'
        label={formatMessage('cardCategory')}
        component={TreeSelectField}
        tree={tree}
        validate={[required()]}
      />
      <div className="create-dialog-form__group flex" style={{justifyContent: 'center', marginTop: 20,
            flexDirection: 'row'}}>
           <button className="btn btn-primary" type="submit">{formatMessage('btnModalSaveCard')}</button>
        </div>
    </form>;
  }
}

const FormContentData = reduxForm({
  form: 'form_card_copy',
  enableReinitialize: true,
})(FormContent);

const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_card_copy')(state),
  categories: state.card.categories_all,
  subject_selcted: state.card.subject_selcted,
  subjects: state.card.subjects,
})

const mapDispatchToProps = {
  setCartItemCopy
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContentData);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/CardCopy/components/FormContent.jsx